export default {
  "100": require('images/emoji/100.png'),
  "1234": require('images/emoji/1234.png'),
  "+1": require('images/emoji/thumbsup.png'),
  "-1": require('images/emoji/thumbsdown.png'),
  "8ball": require('images/emoji/8ball.png'),
  "a": require('images/emoji/a.png'),
  "ab": require('images/emoji/ab.png'),
  "abc": require('images/emoji/abc.png'),
  "abcd": require('images/emoji/abcd.png'),
  "accept": require('images/emoji/accept.png'),
  "aerial_tramway": require('images/emoji/aerial_tramway.png'),
  "airplane": require('images/emoji/airplane.png'),
  "alarm_clock": require('images/emoji/alarm_clock.png'),
  "alien": require('images/emoji/alien.png'),
  "ambulance": require('images/emoji/ambulance.png'),
  "anchor": require('images/emoji/anchor.png'),
  "angel": require('images/emoji/angel.png'),
  "anger": require('images/emoji/anger.png'),
  "angry": require('images/emoji/angry.png'),
  "anguished": require('images/emoji/anguished.png'),
  "ant": require('images/emoji/ant.png'),
  "apple": require('images/emoji/apple.png'),
  "aquarius": require('images/emoji/aquarius.png'),
  "aries": require('images/emoji/aries.png'),
  "arrow_backward": require('images/emoji/arrow_backward.png'),
  "arrow_double_down": require('images/emoji/arrow_double_down.png'),
  "arrow_double_up": require('images/emoji/arrow_double_up.png'),
  "arrow_down": require('images/emoji/arrow_down.png'),
  "arrow_down_small": require('images/emoji/arrow_down_small.png'),
  "arrow_forward": require('images/emoji/arrow_forward.png'),
  "arrow_heading_down": require('images/emoji/arrow_heading_down.png'),
  "arrow_heading_up": require('images/emoji/arrow_heading_up.png'),
  "arrow_left": require('images/emoji/arrow_left.png'),
  "arrow_lower_left": require('images/emoji/arrow_lower_left.png'),
  "arrow_lower_right": require('images/emoji/arrow_lower_right.png'),
  "arrow_right": require('images/emoji/arrow_right.png'),
  "arrow_right_hook": require('images/emoji/arrow_right_hook.png'),
  "arrow_up": require('images/emoji/arrow_up.png'),
  "arrow_up_down": require('images/emoji/arrow_up_down.png'),
  "arrow_up_small": require('images/emoji/arrow_up_small.png'),
  "arrow_upper_left": require('images/emoji/arrow_upper_left.png'),
  "arrow_upper_right": require('images/emoji/arrow_upper_right.png'),
  "arrows_clockwise": require('images/emoji/arrows_clockwise.png'),
  "arrows_counterclockwise": require('images/emoji/arrows_counterclockwise.png'),
  "art": require('images/emoji/art.png'),
  "articulated_lorry": require('images/emoji/articulated_lorry.png'),
  "astonished": require('images/emoji/astonished.png'),
  "athletic_shoe": require('images/emoji/athletic_shoe.png'),
  "atm": require('images/emoji/atm.png'),
  "b": require('images/emoji/b.png'),
  "baby": require('images/emoji/baby.png'),
  "baby_bottle": require('images/emoji/baby_bottle.png'),
  "baby_chick": require('images/emoji/baby_chick.png'),
  "baby_symbol": require('images/emoji/baby_symbol.png'),
  "back": require('images/emoji/back.png'),
  "baggage_claim": require('images/emoji/baggage_claim.png'),
  "balloon": require('images/emoji/balloon.png'),
  "ballot_box_with_check": require('images/emoji/ballot_box_with_check.png'),
  "bamboo": require('images/emoji/bamboo.png'),
  "banana": require('images/emoji/banana.png'),
  "bangbang": require('images/emoji/bangbang.png'),
  "bank": require('images/emoji/bank.png'),
  "bar_chart": require('images/emoji/bar_chart.png'),
  "barber": require('images/emoji/barber.png'),
  "baseball": require('images/emoji/baseball.png'),
  "basketball": require('images/emoji/basketball.png'),
  "bath": require('images/emoji/bath.png'),
  "bathtub": require('images/emoji/bathtub.png'),
  "battery": require('images/emoji/battery.png'),
  "bear": require('images/emoji/bear.png'),
  "bee": require('images/emoji/bee.png'),
  "beer": require('images/emoji/beer.png'),
  "beers": require('images/emoji/beers.png'),
  "beetle": require('images/emoji/beetle.png'),
  "beginner": require('images/emoji/beginner.png'),
  "bell": require('images/emoji/bell.png'),
  "bento": require('images/emoji/bento.png'),
  "bicyclist": require('images/emoji/bicyclist.png'),
  "bike": require('images/emoji/bike.png'),
  "bikini": require('images/emoji/bikini.png'),
  "bird": require('images/emoji/bird.png'),
  "birthday": require('images/emoji/birthday.png'),
  "black_circle": require('images/emoji/black_circle.png'),
  "black_joker": require('images/emoji/black_joker.png'),
  "black_large_square": require('images/emoji/black_large_square.png'),
  "black_medium_small_square": require('images/emoji/black_medium_small_square.png'),
  "black_medium_square": require('images/emoji/black_medium_square.png'),
  "black_nib": require('images/emoji/black_nib.png'),
  "black_small_square": require('images/emoji/black_small_square.png'),
  "black_square_button": require('images/emoji/black_square_button.png'),
  "blossom": require('images/emoji/blossom.png'),
  "blowfish": require('images/emoji/blowfish.png'),
  "blue_book": require('images/emoji/blue_book.png'),
  "blue_car": require('images/emoji/blue_car.png'),
  "blue_heart": require('images/emoji/blue_heart.png'),
  "blush": require('images/emoji/blush.png'),
  "boar": require('images/emoji/boar.png'),
  "boat": require('images/emoji/boat.png'),
  "bomb": require('images/emoji/bomb.png'),
  "book": require('images/emoji/book.png'),
  "bookmark": require('images/emoji/bookmark.png'),
  "bookmark_tabs": require('images/emoji/bookmark_tabs.png'),
  "books": require('images/emoji/books.png'),
  "boom": require('images/emoji/boom.png'),
  "boot": require('images/emoji/boot.png'),
  "bouquet": require('images/emoji/bouquet.png'),
  "bow": require('images/emoji/bow.png'),
  "bowling": require('images/emoji/bowling.png'),
  "bowtie": require('images/emoji/bowtie.png'),
  "boy": require('images/emoji/boy.png'),
  "bread": require('images/emoji/bread.png'),
  "bride_with_veil": require('images/emoji/bride_with_veil.png'),
  "bridge_at_night": require('images/emoji/bridge_at_night.png'),
  "briefcase": require('images/emoji/briefcase.png'),
  "broken_heart": require('images/emoji/broken_heart.png'),
  "bug": require('images/emoji/bug.png'),
  "bulb": require('images/emoji/bulb.png'),
  "bullettrain_front": require('images/emoji/bullettrain_front.png'),
  "bullettrain_side": require('images/emoji/bullettrain_side.png'),
  "bus": require('images/emoji/bus.png'),
  "busstop": require('images/emoji/busstop.png'),
  "bust_in_silhouette": require('images/emoji/bust_in_silhouette.png'),
  "busts_in_silhouette": require('images/emoji/busts_in_silhouette.png'),
  "cactus": require('images/emoji/cactus.png'),
  "cake": require('images/emoji/cake.png'),
  "calendar": require('images/emoji/calendar.png'),
  "calling": require('images/emoji/calling.png'),
  "camel": require('images/emoji/camel.png'),
  "camera": require('images/emoji/camera.png'),
  "cancer": require('images/emoji/cancer.png'),
  "candy": require('images/emoji/candy.png'),
  "capital_abcd": require('images/emoji/capital_abcd.png'),
  "capricorn": require('images/emoji/capricorn.png'),
  "car": require('images/emoji/car.png'),
  "card_index": require('images/emoji/card_index.png'),
  "carousel_horse": require('images/emoji/carousel_horse.png'),
  "cat": require('images/emoji/cat.png'),
  "cat2": require('images/emoji/cat2.png'),
  "cd": require('images/emoji/cd.png'),
  "chart": require('images/emoji/chart.png'),
  "chart_with_downwards_trend": require('images/emoji/chart_with_downwards_trend.png'),
  "chart_with_upwards_trend": require('images/emoji/chart_with_upwards_trend.png'),
  "checkered_flag": require('images/emoji/checkered_flag.png'),
  "cherries": require('images/emoji/cherries.png'),
  "cherry_blossom": require('images/emoji/cherry_blossom.png'),
  "chestnut": require('images/emoji/chestnut.png'),
  "chicken": require('images/emoji/chicken.png'),
  "children_crossing": require('images/emoji/children_crossing.png'),
  "chocolate_bar": require('images/emoji/chocolate_bar.png'),
  "christmas_tree": require('images/emoji/christmas_tree.png'),
  "church": require('images/emoji/church.png'),
  "cinema": require('images/emoji/cinema.png'),
  "circus_tent": require('images/emoji/circus_tent.png'),
  "city_sunrise": require('images/emoji/city_sunrise.png'),
  "city_sunset": require('images/emoji/city_sunset.png'),
  "cl": require('images/emoji/cl.png'),
  "clap": require('images/emoji/clap.png'),
  "clapper": require('images/emoji/clapper.png'),
  "clipboard": require('images/emoji/clipboard.png'),
  "clock1": require('images/emoji/clock1.png'),
  "clock10": require('images/emoji/clock10.png'),
  "clock1030": require('images/emoji/clock1030.png'),
  "clock11": require('images/emoji/clock11.png'),
  "clock1130": require('images/emoji/clock1130.png'),
  "clock12": require('images/emoji/clock12.png'),
  "clock1230": require('images/emoji/clock1230.png'),
  "clock130": require('images/emoji/clock130.png'),
  "clock2": require('images/emoji/clock2.png'),
  "clock230": require('images/emoji/clock230.png'),
  "clock3": require('images/emoji/clock3.png'),
  "clock330": require('images/emoji/clock330.png'),
  "clock4": require('images/emoji/clock4.png'),
  "clock430": require('images/emoji/clock430.png'),
  "clock5": require('images/emoji/clock5.png'),
  "clock530": require('images/emoji/clock530.png'),
  "clock6": require('images/emoji/clock6.png'),
  "clock630": require('images/emoji/clock630.png'),
  "clock7": require('images/emoji/clock7.png'),
  "clock730": require('images/emoji/clock730.png'),
  "clock8": require('images/emoji/clock8.png'),
  "clock830": require('images/emoji/clock830.png'),
  "clock9": require('images/emoji/clock9.png'),
  "clock930": require('images/emoji/clock930.png'),
  "closed_book": require('images/emoji/closed_book.png'),
  "closed_lock_with_key": require('images/emoji/closed_lock_with_key.png'),
  "closed_umbrella": require('images/emoji/closed_umbrella.png'),
  "cloud": require('images/emoji/cloud.png'),
  "clubs": require('images/emoji/clubs.png'),
  "cn": require('images/emoji/cn.png'),
  "cocktail": require('images/emoji/cocktail.png'),
  "coffee": require('images/emoji/coffee.png'),
  "cold_sweat": require('images/emoji/cold_sweat.png'),
  "collision": require('images/emoji/collision.png'),
  "computer": require('images/emoji/computer.png'),
  "confetti_ball": require('images/emoji/confetti_ball.png'),
  "confounded": require('images/emoji/confounded.png'),
  "confused": require('images/emoji/confused.png'),
  "congratulations": require('images/emoji/congratulations.png'),
  "construction": require('images/emoji/construction.png'),
  "construction_worker": require('images/emoji/construction_worker.png'),
  "convenience_store": require('images/emoji/convenience_store.png'),
  "cookie": require('images/emoji/cookie.png'),
  "cool": require('images/emoji/cool.png'),
  "cop": require('images/emoji/cop.png'),
  "copyright": require('images/emoji/copyright.png'),
  "corn": require('images/emoji/corn.png'),
  "couple": require('images/emoji/couple.png'),
  "couple_with_heart": require('images/emoji/couple_with_heart.png'),
  "couplekiss": require('images/emoji/couplekiss.png'),
  "cow": require('images/emoji/cow.png'),
  "cow2": require('images/emoji/cow2.png'),
  "credit_card": require('images/emoji/credit_card.png'),
  "crescent_moon": require('images/emoji/crescent_moon.png'),
  "crocodile": require('images/emoji/crocodile.png'),
  "crossed_flags": require('images/emoji/crossed_flags.png'),
  "crown": require('images/emoji/crown.png'),
  "cry": require('images/emoji/cry.png'),
  "crying_cat_face": require('images/emoji/crying_cat_face.png'),
  "crystal_ball": require('images/emoji/crystal_ball.png'),
  "cupid": require('images/emoji/cupid.png'),
  "curly_loop": require('images/emoji/curly_loop.png'),
  "currency_exchange": require('images/emoji/currency_exchange.png'),
  "curry": require('images/emoji/curry.png'),
  "custard": require('images/emoji/custard.png'),
  "customs": require('images/emoji/customs.png'),
  "cyclone": require('images/emoji/cyclone.png'),
  "dancer": require('images/emoji/dancer.png'),
  "dancers": require('images/emoji/dancers.png'),
  "dango": require('images/emoji/dango.png'),
  "dart": require('images/emoji/dart.png'),
  "dash": require('images/emoji/dash.png'),
  "date": require('images/emoji/date.png'),
  "de": require('images/emoji/de.png'),
  "deciduous_tree": require('images/emoji/deciduous_tree.png'),
  "department_store": require('images/emoji/department_store.png'),
  "diamond_shape_with_a_dot_inside": require('images/emoji/diamond_shape_with_a_dot_inside.png'),
  "diamonds": require('images/emoji/diamonds.png'),
  "disappointed": require('images/emoji/disappointed.png'),
  "disappointed_relieved": require('images/emoji/disappointed_relieved.png'),
  "dizzy": require('images/emoji/dizzy.png'),
  "dizzy_face": require('images/emoji/dizzy_face.png'),
  "do_not_litter": require('images/emoji/do_not_litter.png'),
  "dog": require('images/emoji/dog.png'),
  "dog2": require('images/emoji/dog2.png'),
  "dollar": require('images/emoji/dollar.png'),
  "dolls": require('images/emoji/dolls.png'),
  "dolphin": require('images/emoji/dolphin.png'),
  "door": require('images/emoji/door.png'),
  "doughnut": require('images/emoji/doughnut.png'),
  "dragon": require('images/emoji/dragon.png'),
  "dragon_face": require('images/emoji/dragon_face.png'),
  "dress": require('images/emoji/dress.png'),
  "dromedary_camel": require('images/emoji/dromedary_camel.png'),
  "droplet": require('images/emoji/droplet.png'),
  "dvd": require('images/emoji/dvd.png'),
  "e-mail": require('images/emoji/e-mail.png'),
  "ear": require('images/emoji/ear.png'),
  "ear_of_rice": require('images/emoji/ear_of_rice.png'),
  "earth_africa": require('images/emoji/earth_africa.png'),
  "earth_americas": require('images/emoji/earth_americas.png'),
  "earth_asia": require('images/emoji/earth_asia.png'),
  "egg": require('images/emoji/egg.png'),
  "eggplant": require('images/emoji/eggplant.png'),
  "eight": require('images/emoji/eight.png'),
  "eight_pointed_black_star": require('images/emoji/eight_pointed_black_star.png'),
  "eight_spoked_asterisk": require('images/emoji/eight_spoked_asterisk.png'),
  "electric_plug": require('images/emoji/electric_plug.png'),
  "elephant": require('images/emoji/elephant.png'),
  "email": require('images/emoji/email.png'),
  "end": require('images/emoji/end.png'),
  "envelope": require('images/emoji/envelope.png'),
  "envelope_with_arrow": require('images/emoji/envelope_with_arrow.png'),
  "es": require('images/emoji/es.png'),
  "euro": require('images/emoji/euro.png'),
  "european_castle": require('images/emoji/european_castle.png'),
  "european_post_office": require('images/emoji/european_post_office.png'),
  "evergreen_tree": require('images/emoji/evergreen_tree.png'),
  "exclamation": require('images/emoji/exclamation.png'),
  "expressionless": require('images/emoji/expressionless.png'),
  "eyeglasses": require('images/emoji/eyeglasses.png'),
  "eyes": require('images/emoji/eyes.png'),
  "facepalm": require('images/emoji/facepalm.png'),
  "facepunch": require('images/emoji/facepunch.png'),
  "factory": require('images/emoji/factory.png'),
  "fallen_leaf": require('images/emoji/fallen_leaf.png'),
  "family": require('images/emoji/family.png'),
  "fast_forward": require('images/emoji/fast_forward.png'),
  "fax": require('images/emoji/fax.png'),
  "fearful": require('images/emoji/fearful.png'),
  "feelsgood": require('images/emoji/feelsgood.png'),
  "feet": require('images/emoji/feet.png'),
  "ferris_wheel": require('images/emoji/ferris_wheel.png'),
  "file_folder": require('images/emoji/file_folder.png'),
  "finnadie": require('images/emoji/finnadie.png'),
  "fire": require('images/emoji/fire.png'),
  "fire_engine": require('images/emoji/fire_engine.png'),
  "fireworks": require('images/emoji/fireworks.png'),
  "first_quarter_moon": require('images/emoji/first_quarter_moon.png'),
  "first_quarter_moon_with_face": require('images/emoji/first_quarter_moon_with_face.png'),
  "fish": require('images/emoji/fish.png'),
  "fish_cake": require('images/emoji/fish_cake.png'),
  "fishing_pole_and_fish": require('images/emoji/fishing_pole_and_fish.png'),
  "fist": require('images/emoji/fist.png'),
  "five": require('images/emoji/five.png'),
  "flags": require('images/emoji/flags.png'),
  "flashlight": require('images/emoji/flashlight.png'),
  "flipper": require('images/emoji/flipper.png'),
  "floppy_disk": require('images/emoji/floppy_disk.png'),
  "flower_playing_cards": require('images/emoji/flower_playing_cards.png'),
  "flushed": require('images/emoji/flushed.png'),
  "foggy": require('images/emoji/foggy.png'),
  "football": require('images/emoji/football.png'),
  "footprints": require('images/emoji/footprints.png'),
  "fork_and_knife": require('images/emoji/fork_and_knife.png'),
  "fountain": require('images/emoji/fountain.png'),
  "four": require('images/emoji/four.png'),
  "four_leaf_clover": require('images/emoji/four_leaf_clover.png'),
  "fr": require('images/emoji/fr.png'),
  "free": require('images/emoji/free.png'),
  "fried_shrimp": require('images/emoji/fried_shrimp.png'),
  "fries": require('images/emoji/fries.png'),
  "frog": require('images/emoji/frog.png'),
  "frowning": require('images/emoji/frowning.png'),
  "fu": require('images/emoji/fu.png'),
  "fuelpump": require('images/emoji/fuelpump.png'),
  "full_moon": require('images/emoji/full_moon.png'),
  "full_moon_with_face": require('images/emoji/full_moon_with_face.png'),
  "game_die": require('images/emoji/game_die.png'),
  "gb": require('images/emoji/gb.png'),
  "gem": require('images/emoji/gem.png'),
  "gemini": require('images/emoji/gemini.png'),
  "ghost": require('images/emoji/ghost.png'),
  "gift": require('images/emoji/gift.png'),
  "gift_heart": require('images/emoji/gift_heart.png'),
  "girl": require('images/emoji/girl.png'),
  "globe_with_meridians": require('images/emoji/globe_with_meridians.png'),
  "goat": require('images/emoji/goat.png'),
  "goberserk": require('images/emoji/goberserk.png'),
  "godmode": require('images/emoji/godmode.png'),
  "golf": require('images/emoji/golf.png'),
  "grapes": require('images/emoji/grapes.png'),
  "green_apple": require('images/emoji/green_apple.png'),
  "green_book": require('images/emoji/green_book.png'),
  "green_heart": require('images/emoji/green_heart.png'),
  "grey_exclamation": require('images/emoji/grey_exclamation.png'),
  "grey_question": require('images/emoji/grey_question.png'),
  "grimacing": require('images/emoji/grimacing.png'),
  "grin": require('images/emoji/grin.png'),
  "grinning": require('images/emoji/grinning.png'),
  "guardsman": require('images/emoji/guardsman.png'),
  "guitar": require('images/emoji/guitar.png'),
  "gun": require('images/emoji/gun.png'),
  "haircut": require('images/emoji/haircut.png'),
  "hamburger": require('images/emoji/hamburger.png'),
  "hammer": require('images/emoji/hammer.png'),
  "hamster": require('images/emoji/hamster.png'),
  "hand": require('images/emoji/hand.png'),
  "handbag": require('images/emoji/handbag.png'),
  "hankey": require('images/emoji/hankey.png'),
  "hash": require('images/emoji/hash.png'),
  "hatched_chick": require('images/emoji/hatched_chick.png'),
  "hatching_chick": require('images/emoji/hatching_chick.png'),
  "headphones": require('images/emoji/headphones.png'),
  "hear_no_evil": require('images/emoji/hear_no_evil.png'),
  "heart": require('images/emoji/heart.png'),
  "heart_decoration": require('images/emoji/heart_decoration.png'),
  "heart_eyes": require('images/emoji/heart_eyes.png'),
  "heart_eyes_cat": require('images/emoji/heart_eyes_cat.png'),
  "heartbeat": require('images/emoji/heartbeat.png'),
  "heartpulse": require('images/emoji/heartpulse.png'),
  "hearts": require('images/emoji/hearts.png'),
  "heavy_check_mark": require('images/emoji/heavy_check_mark.png'),
  "heavy_division_sign": require('images/emoji/heavy_division_sign.png'),
  "heavy_dollar_sign": require('images/emoji/heavy_dollar_sign.png'),
  "heavy_exclamation_mark": require('images/emoji/heavy_exclamation_mark.png'),
  "heavy_minus_sign": require('images/emoji/heavy_minus_sign.png'),
  "heavy_multiplication_x": require('images/emoji/heavy_multiplication_x.png'),
  "heavy_plus_sign": require('images/emoji/heavy_plus_sign.png'),
  "helicopter": require('images/emoji/helicopter.png'),
  "herb": require('images/emoji/herb.png'),
  "hibiscus": require('images/emoji/hibiscus.png'),
  "high_brightness": require('images/emoji/high_brightness.png'),
  "high_heel": require('images/emoji/high_heel.png'),
  "hocho": require('images/emoji/hocho.png'),
  "honey_pot": require('images/emoji/honey_pot.png'),
  "honeybee": require('images/emoji/honeybee.png'),
  "horse": require('images/emoji/horse.png'),
  "horse_racing": require('images/emoji/horse_racing.png'),
  "hospital": require('images/emoji/hospital.png'),
  "hotel": require('images/emoji/hotel.png'),
  "hotsprings": require('images/emoji/hotsprings.png'),
  "hourglass": require('images/emoji/hourglass.png'),
  "hourglass_flowing_sand": require('images/emoji/hourglass_flowing_sand.png'),
  "house": require('images/emoji/house.png'),
  "house_with_garden": require('images/emoji/house_with_garden.png'),
  "hurtrealbad": require('images/emoji/hurtrealbad.png'),
  "hushed": require('images/emoji/hushed.png'),
  "ice_cream": require('images/emoji/ice_cream.png'),
  "icecream": require('images/emoji/icecream.png'),
  "id": require('images/emoji/id.png'),
  "ideograph_advantage": require('images/emoji/ideograph_advantage.png'),
  "imp": require('images/emoji/imp.png'),
  "inbox_tray": require('images/emoji/inbox_tray.png'),
  "incoming_envelope": require('images/emoji/incoming_envelope.png'),
  "information_desk_person": require('images/emoji/information_desk_person.png'),
  "information_source": require('images/emoji/information_source.png'),
  "innocent": require('images/emoji/innocent.png'),
  "interrobang": require('images/emoji/interrobang.png'),
  "iphone": require('images/emoji/iphone.png'),
  "it": require('images/emoji/it.png'),
  "izakaya_lantern": require('images/emoji/izakaya_lantern.png'),
  "jack_o_lantern": require('images/emoji/jack_o_lantern.png'),
  "japan": require('images/emoji/japan.png'),
  "japanese_castle": require('images/emoji/japanese_castle.png'),
  "japanese_goblin": require('images/emoji/japanese_goblin.png'),
  "japanese_ogre": require('images/emoji/japanese_ogre.png'),
  "jeans": require('images/emoji/jeans.png'),
  "joy": require('images/emoji/joy.png'),
  "joy_cat": require('images/emoji/joy_cat.png'),
  "jp": require('images/emoji/jp.png'),
  "key": require('images/emoji/key.png'),
  "keycap_ten": require('images/emoji/keycap_ten.png'),
  "kimono": require('images/emoji/kimono.png'),
  "kiss": require('images/emoji/kiss.png'),
  "kissing": require('images/emoji/kissing.png'),
  "kissing_cat": require('images/emoji/kissing_cat.png'),
  "kissing_closed_eyes": require('images/emoji/kissing_closed_eyes.png'),
  "kissing_heart": require('images/emoji/kissing_heart.png'),
  "kissing_smiling_eyes": require('images/emoji/kissing_smiling_eyes.png'),
  "koala": require('images/emoji/koala.png'),
  "koko": require('images/emoji/koko.png'),
  "kr": require('images/emoji/kr.png'),
  "lantern": require('images/emoji/lantern.png'),
  "large_blue_circle": require('images/emoji/large_blue_circle.png'),
  "large_blue_diamond": require('images/emoji/large_blue_diamond.png'),
  "large_orange_diamond": require('images/emoji/large_orange_diamond.png'),
  "last_quarter_moon": require('images/emoji/last_quarter_moon.png'),
  "last_quarter_moon_with_face": require('images/emoji/last_quarter_moon_with_face.png'),
  "laughing": require('images/emoji/laughing.png'),
  "leaves": require('images/emoji/leaves.png'),
  "ledger": require('images/emoji/ledger.png'),
  "left_luggage": require('images/emoji/left_luggage.png'),
  "left_right_arrow": require('images/emoji/left_right_arrow.png'),
  "leftwards_arrow_with_hook": require('images/emoji/leftwards_arrow_with_hook.png'),
  "lemon": require('images/emoji/lemon.png'),
  "leo": require('images/emoji/leo.png'),
  "leopard": require('images/emoji/leopard.png'),
  "libra": require('images/emoji/libra.png'),
  "light_rail": require('images/emoji/light_rail.png'),
  "link": require('images/emoji/link.png'),
  "lips": require('images/emoji/lips.png'),
  "lipstick": require('images/emoji/lipstick.png'),
  "lock": require('images/emoji/lock.png'),
  "lock_with_ink_pen": require('images/emoji/lock_with_ink_pen.png'),
  "lollipop": require('images/emoji/lollipop.png'),
  "loop": require('images/emoji/loop.png'),
  "loudspeaker": require('images/emoji/loudspeaker.png'),
  "love_hotel": require('images/emoji/love_hotel.png'),
  "love_letter": require('images/emoji/love_letter.png'),
  "low_brightness": require('images/emoji/low_brightness.png'),
  "m": require('images/emoji/m.png'),
  "mag": require('images/emoji/mag.png'),
  "mag_right": require('images/emoji/mag_right.png'),
  "mahjong": require('images/emoji/mahjong.png'),
  "mailbox": require('images/emoji/mailbox.png'),
  "mailbox_closed": require('images/emoji/mailbox_closed.png'),
  "mailbox_with_mail": require('images/emoji/mailbox_with_mail.png'),
  "mailbox_with_no_mail": require('images/emoji/mailbox_with_no_mail.png'),
  "man": require('images/emoji/man.png'),
  "man_with_gua_pi_mao": require('images/emoji/man_with_gua_pi_mao.png'),
  "man_with_turban": require('images/emoji/man_with_turban.png'),
  "mans_shoe": require('images/emoji/mans_shoe.png'),
  "maple_leaf": require('images/emoji/maple_leaf.png'),
  "mask": require('images/emoji/mask.png'),
  "massage": require('images/emoji/massage.png'),
  "meat_on_bone": require('images/emoji/meat_on_bone.png'),
  "mega": require('images/emoji/mega.png'),
  "melon": require('images/emoji/melon.png'),
  "memo": require('images/emoji/memo.png'),
  "mens": require('images/emoji/mens.png'),
  "metal": require('images/emoji/metal.png'),
  "metro": require('images/emoji/metro.png'),
  "microphone": require('images/emoji/microphone.png'),
  "microscope": require('images/emoji/microscope.png'),
  "milky_way": require('images/emoji/milky_way.png'),
  "minibus": require('images/emoji/minibus.png'),
  "minidisc": require('images/emoji/minidisc.png'),
  "mobile_phone_off": require('images/emoji/mobile_phone_off.png'),
  "money_with_wings": require('images/emoji/money_with_wings.png'),
  "moneybag": require('images/emoji/moneybag.png'),
  "monkey": require('images/emoji/monkey.png'),
  "monkey_face": require('images/emoji/monkey_face.png'),
  "monorail": require('images/emoji/monorail.png'),
  "moon": require('images/emoji/moon.png'),
  "mortar_board": require('images/emoji/mortar_board.png'),
  "mount_fuji": require('images/emoji/mount_fuji.png'),
  "mountain_bicyclist": require('images/emoji/mountain_bicyclist.png'),
  "mountain_cableway": require('images/emoji/mountain_cableway.png'),
  "mountain_railway": require('images/emoji/mountain_railway.png'),
  "mouse": require('images/emoji/mouse.png'),
  "mouse2": require('images/emoji/mouse2.png'),
  "movie_camera": require('images/emoji/movie_camera.png'),
  "moyai": require('images/emoji/moyai.png'),
  "muscle": require('images/emoji/muscle.png'),
  "mushroom": require('images/emoji/mushroom.png'),
  "musical_keyboard": require('images/emoji/musical_keyboard.png'),
  "musical_note": require('images/emoji/musical_note.png'),
  "musical_score": require('images/emoji/musical_score.png'),
  "mute": require('images/emoji/mute.png'),
  "nail_care": require('images/emoji/nail_care.png'),
  "name_badge": require('images/emoji/name_badge.png'),
  "neckbeard": require('images/emoji/neckbeard.png'),
  "necktie": require('images/emoji/necktie.png'),
  "negative_squared_cross_mark": require('images/emoji/negative_squared_cross_mark.png'),
  "neutral_face": require('images/emoji/neutral_face.png'),
  "new": require('images/emoji/new.png'),
  "new_moon": require('images/emoji/new_moon.png'),
  "new_moon_with_face": require('images/emoji/new_moon_with_face.png'),
  "newspaper": require('images/emoji/newspaper.png'),
  "ng": require('images/emoji/ng.png'),
  "nine": require('images/emoji/nine.png'),
  "no_bell": require('images/emoji/no_bell.png'),
  "no_bicycles": require('images/emoji/no_bicycles.png'),
  "no_entry": require('images/emoji/no_entry.png'),
  "no_entry_sign": require('images/emoji/no_entry_sign.png'),
  "no_good": require('images/emoji/no_good.png'),
  "no_mobile_phones": require('images/emoji/no_mobile_phones.png'),
  "no_mouth": require('images/emoji/no_mouth.png'),
  "no_pedestrians": require('images/emoji/no_pedestrians.png'),
  "no_smoking": require('images/emoji/no_smoking.png'),
  "non-potable_water": require('images/emoji/non-potable_water.png'),
  "nose": require('images/emoji/nose.png'),
  "notebook": require('images/emoji/notebook.png'),
  "notebook_with_decorative_cover": require('images/emoji/notebook_with_decorative_cover.png'),
  "notes": require('images/emoji/notes.png'),
  "nut_and_bolt": require('images/emoji/nut_and_bolt.png'),
  "o": require('images/emoji/o.png'),
  "o2": require('images/emoji/o2.png'),
  "ocean": require('images/emoji/ocean.png'),
  "octocat": require('images/emoji/octocat.png'),
  "octopus": require('images/emoji/octopus.png'),
  "oden": require('images/emoji/oden.png'),
  "office": require('images/emoji/office.png'),
  "ok": require('images/emoji/ok.png'),
  "ok_hand": require('images/emoji/ok_hand.png'),
  "ok_woman": require('images/emoji/ok_woman.png'),
  "older_man": require('images/emoji/older_man.png'),
  "older_woman": require('images/emoji/older_woman.png'),
  "on": require('images/emoji/on.png'),
  "oncoming_automobile": require('images/emoji/oncoming_automobile.png'),
  "oncoming_bus": require('images/emoji/oncoming_bus.png'),
  "oncoming_police_car": require('images/emoji/oncoming_police_car.png'),
  "oncoming_taxi": require('images/emoji/oncoming_taxi.png'),
  "one": require('images/emoji/one.png'),
  "open_book": require('images/emoji/open_book.png'),
  "open_file_folder": require('images/emoji/open_file_folder.png'),
  "open_hands": require('images/emoji/open_hands.png'),
  "open_mouth": require('images/emoji/open_mouth.png'),
  "ophiuchus": require('images/emoji/ophiuchus.png'),
  "orange_book": require('images/emoji/orange_book.png'),
  "outbox_tray": require('images/emoji/outbox_tray.png'),
  "ox": require('images/emoji/ox.png'),
  "package": require('images/emoji/package.png'),
  "page_facing_up": require('images/emoji/page_facing_up.png'),
  "page_with_curl": require('images/emoji/page_with_curl.png'),
  "pager": require('images/emoji/pager.png'),
  "palm_tree": require('images/emoji/palm_tree.png'),
  "panda_face": require('images/emoji/panda_face.png'),
  "paperclip": require('images/emoji/paperclip.png'),
  "parking": require('images/emoji/parking.png'),
  "part_alternation_mark": require('images/emoji/part_alternation_mark.png'),
  "partly_sunny": require('images/emoji/partly_sunny.png'),
  "passport_control": require('images/emoji/passport_control.png'),
  "paw_prints": require('images/emoji/paw_prints.png'),
  "peach": require('images/emoji/peach.png'),
  "pear": require('images/emoji/pear.png'),
  "pencil": require('images/emoji/pencil.png'),
  "pencil2": require('images/emoji/pencil2.png'),
  "penguin": require('images/emoji/penguin.png'),
  "pensive": require('images/emoji/pensive.png'),
  "performing_arts": require('images/emoji/performing_arts.png'),
  "persevere": require('images/emoji/persevere.png'),
  "person_frowning": require('images/emoji/person_frowning.png'),
  "person_with_blond_hair": require('images/emoji/person_with_blond_hair.png'),
  "person_with_pouting_face": require('images/emoji/person_with_pouting_face.png'),
  "phone": require('images/emoji/phone.png'),
  "pig": require('images/emoji/pig.png'),
  "pig2": require('images/emoji/pig2.png'),
  "pig_nose": require('images/emoji/pig_nose.png'),
  "pill": require('images/emoji/pill.png'),
  "pineapple": require('images/emoji/pineapple.png'),
  "pisces": require('images/emoji/pisces.png'),
  "pizza": require('images/emoji/pizza.png'),
  "point_down": require('images/emoji/point_down.png'),
  "point_left": require('images/emoji/point_left.png'),
  "point_right": require('images/emoji/point_right.png'),
  "point_up": require('images/emoji/point_up.png'),
  "point_up_2": require('images/emoji/point_up_2.png'),
  "police_car": require('images/emoji/police_car.png'),
  "poodle": require('images/emoji/poodle.png'),
  "poop": require('images/emoji/poop.png'),
  "post_office": require('images/emoji/post_office.png'),
  "postal_horn": require('images/emoji/postal_horn.png'),
  "postbox": require('images/emoji/postbox.png'),
  "potable_water": require('images/emoji/potable_water.png'),
  "pouch": require('images/emoji/pouch.png'),
  "poultry_leg": require('images/emoji/poultry_leg.png'),
  "pound": require('images/emoji/pound.png'),
  "pouting_cat": require('images/emoji/pouting_cat.png'),
  "pray": require('images/emoji/pray.png'),
  "princess": require('images/emoji/princess.png'),
  "punch": require('images/emoji/punch.png'),
  "purple_heart": require('images/emoji/purple_heart.png'),
  "purse": require('images/emoji/purse.png'),
  "pushpin": require('images/emoji/pushpin.png'),
  "put_litter_in_its_place": require('images/emoji/put_litter_in_its_place.png'),
  "question": require('images/emoji/question.png'),
  "rabbit": require('images/emoji/rabbit.png'),
  "rabbit2": require('images/emoji/rabbit2.png'),
  "racehorse": require('images/emoji/racehorse.png'),
  "radio": require('images/emoji/radio.png'),
  "radio_button": require('images/emoji/radio_button.png'),
  "rage": require('images/emoji/rage.png'),
  "rage1": require('images/emoji/rage1.png'),
  "rage2": require('images/emoji/rage2.png'),
  "rage3": require('images/emoji/rage3.png'),
  "rage4": require('images/emoji/rage4.png'),
  "railway_car": require('images/emoji/railway_car.png'),
  "rainbow": require('images/emoji/rainbow.png'),
  "raised_hand": require('images/emoji/raised_hand.png'),
  "raised_hands": require('images/emoji/raised_hands.png'),
  "raising_hand": require('images/emoji/raising_hand.png'),
  "ram": require('images/emoji/ram.png'),
  "ramen": require('images/emoji/ramen.png'),
  "rat": require('images/emoji/rat.png'),
  "recycle": require('images/emoji/recycle.png'),
  "red_car": require('images/emoji/red_car.png'),
  "red_circle": require('images/emoji/red_circle.png'),
  "registered": require('images/emoji/registered.png'),
  "relaxed": require('images/emoji/relaxed.png'),
  "relieved": require('images/emoji/relieved.png'),
  "repeat": require('images/emoji/repeat.png'),
  "repeat_one": require('images/emoji/repeat_one.png'),
  "restroom": require('images/emoji/restroom.png'),
  "revolving_hearts": require('images/emoji/revolving_hearts.png'),
  "rewind": require('images/emoji/rewind.png'),
  "ribbon": require('images/emoji/ribbon.png'),
  "rice": require('images/emoji/rice.png'),
  "rice_ball": require('images/emoji/rice_ball.png'),
  "rice_cracker": require('images/emoji/rice_cracker.png'),
  "rice_scene": require('images/emoji/rice_scene.png'),
  "ring": require('images/emoji/ring.png'),
  "rocket": require('images/emoji/rocket.png'),
  "roller_coaster": require('images/emoji/roller_coaster.png'),
  "rooster": require('images/emoji/rooster.png'),
  "rose": require('images/emoji/rose.png'),
  "rotating_light": require('images/emoji/rotating_light.png'),
  "round_pushpin": require('images/emoji/round_pushpin.png'),
  "rowboat": require('images/emoji/rowboat.png'),
  "ru": require('images/emoji/ru.png'),
  "rugby_football": require('images/emoji/rugby_football.png'),
  "runner": require('images/emoji/runner.png'),
  "running": require('images/emoji/running.png'),
  "running_shirt_with_sash": require('images/emoji/running_shirt_with_sash.png'),
  "sa": require('images/emoji/sa.png'),
  "sagittarius": require('images/emoji/sagittarius.png'),
  "sailboat": require('images/emoji/sailboat.png'),
  "sake": require('images/emoji/sake.png'),
  "sandal": require('images/emoji/sandal.png'),
  "santa": require('images/emoji/santa.png'),
  "satellite": require('images/emoji/satellite.png'),
  "satisfied": require('images/emoji/satisfied.png'),
  "saxophone": require('images/emoji/saxophone.png'),
  "school": require('images/emoji/school.png'),
  "school_satchel": require('images/emoji/school_satchel.png'),
  "scissors": require('images/emoji/scissors.png'),
  "scorpius": require('images/emoji/scorpius.png'),
  "scream": require('images/emoji/scream.png'),
  "scream_cat": require('images/emoji/scream_cat.png'),
  "scroll": require('images/emoji/scroll.png'),
  "seat": require('images/emoji/seat.png'),
  "secret": require('images/emoji/secret.png'),
  "see_no_evil": require('images/emoji/see_no_evil.png'),
  "seedling": require('images/emoji/seedling.png'),
  "seven": require('images/emoji/seven.png'),
  "shaved_ice": require('images/emoji/shaved_ice.png'),
  "sheep": require('images/emoji/sheep.png'),
  "shell": require('images/emoji/shell.png'),
  "ship": require('images/emoji/ship.png'),
  "shipit": require('images/emoji/shipit.png'),
  "shirt": require('images/emoji/shirt.png'),
  "shit": require('images/emoji/shit.png'),
  "shoe": require('images/emoji/shoe.png'),
  "shower": require('images/emoji/shower.png'),
  "signal_strength": require('images/emoji/signal_strength.png'),
  "six": require('images/emoji/six.png'),
  "six_pointed_star": require('images/emoji/six_pointed_star.png'),
  "ski": require('images/emoji/ski.png'),
  "skull": require('images/emoji/skull.png'),
  "sleeping": require('images/emoji/sleeping.png'),
  "sleepy": require('images/emoji/sleepy.png'),
  "slot_machine": require('images/emoji/slot_machine.png'),
  "small_blue_diamond": require('images/emoji/small_blue_diamond.png'),
  "small_orange_diamond": require('images/emoji/small_orange_diamond.png'),
  "small_red_triangle": require('images/emoji/small_red_triangle.png'),
  "small_red_triangle_down": require('images/emoji/small_red_triangle_down.png'),
  "smile": require('images/emoji/smile.png'),
  "smile_cat": require('images/emoji/smile_cat.png'),
  "smiley": require('images/emoji/smiley.png'),
  "smiley_cat": require('images/emoji/smiley_cat.png'),
  "smiling_imp": require('images/emoji/smiling_imp.png'),
  "smirk": require('images/emoji/smirk.png'),
  "smirk_cat": require('images/emoji/smirk_cat.png'),
  "smoking": require('images/emoji/smoking.png'),
  "snail": require('images/emoji/snail.png'),
  "snake": require('images/emoji/snake.png'),
  "snowboarder": require('images/emoji/snowboarder.png'),
  "snowflake": require('images/emoji/snowflake.png'),
  "snowman": require('images/emoji/snowman.png'),
  "sob": require('images/emoji/sob.png'),
  "soccer": require('images/emoji/soccer.png'),
  "soon": require('images/emoji/soon.png'),
  "sos": require('images/emoji/sos.png'),
  "sound": require('images/emoji/sound.png'),
  "space_invader": require('images/emoji/space_invader.png'),
  "spades": require('images/emoji/spades.png'),
  "spaghetti": require('images/emoji/spaghetti.png'),
  "sparkle": require('images/emoji/sparkle.png'),
  "sparkler": require('images/emoji/sparkler.png'),
  "sparkles": require('images/emoji/sparkles.png'),
  "sparkling_heart": require('images/emoji/sparkling_heart.png'),
  "speak_no_evil": require('images/emoji/speak_no_evil.png'),
  "speaker": require('images/emoji/speaker.png'),
  "speech_balloon": require('images/emoji/speech_balloon.png'),
  "speedboat": require('images/emoji/speedboat.png'),
  "squirrel": require('images/emoji/squirrel.png'),
  "star": require('images/emoji/star.png'),
  "star2": require('images/emoji/star2.png'),
  "stars": require('images/emoji/stars.png'),
  "station": require('images/emoji/station.png'),
  "statue_of_liberty": require('images/emoji/statue_of_liberty.png'),
  "steam_locomotive": require('images/emoji/steam_locomotive.png'),
  "stew": require('images/emoji/stew.png'),
  "straight_ruler": require('images/emoji/straight_ruler.png'),
  "strawberry": require('images/emoji/strawberry.png'),
  "stuck_out_tongue": require('images/emoji/stuck_out_tongue.png'),
  "stuck_out_tongue_closed_eyes": require('images/emoji/stuck_out_tongue_closed_eyes.png'),
  "stuck_out_tongue_winking_eye": require('images/emoji/stuck_out_tongue_winking_eye.png'),
  "sun_with_face": require('images/emoji/sun_with_face.png'),
  "sunflower": require('images/emoji/sunflower.png'),
  "sunglasses": require('images/emoji/sunglasses.png'),
  "sunny": require('images/emoji/sunny.png'),
  "sunrise": require('images/emoji/sunrise.png'),
  "sunrise_over_mountains": require('images/emoji/sunrise_over_mountains.png'),
  "surfer": require('images/emoji/surfer.png'),
  "sushi": require('images/emoji/sushi.png'),
  "suspect": require('images/emoji/suspect.png'),
  "suspension_railway": require('images/emoji/suspension_railway.png'),
  "sweat": require('images/emoji/sweat.png'),
  "sweat_drops": require('images/emoji/sweat_drops.png'),
  "sweat_smile": require('images/emoji/sweat_smile.png'),
  "sweet_potato": require('images/emoji/sweet_potato.png'),
  "swimmer": require('images/emoji/swimmer.png'),
  "symbols": require('images/emoji/symbols.png'),
  "syringe": require('images/emoji/syringe.png'),
  "tada": require('images/emoji/tada.png'),
  "tanabata_tree": require('images/emoji/tanabata_tree.png'),
  "tangerine": require('images/emoji/tangerine.png'),
  "taurus": require('images/emoji/taurus.png'),
  "taxi": require('images/emoji/taxi.png'),
  "tea": require('images/emoji/tea.png'),
  "telephone": require('images/emoji/telephone.png'),
  "telephone_receiver": require('images/emoji/telephone_receiver.png'),
  "telescope": require('images/emoji/telescope.png'),
  "tennis": require('images/emoji/tennis.png'),
  "tent": require('images/emoji/tent.png'),
  "thought_balloon": require('images/emoji/thought_balloon.png'),
  "three": require('images/emoji/three.png'),
  "thumbsdown": require('images/emoji/thumbsdown.png'),
  "thumbsup": require('images/emoji/thumbsup.png'),
  "ticket": require('images/emoji/ticket.png'),
  "tiger": require('images/emoji/tiger.png'),
  "tiger2": require('images/emoji/tiger2.png'),
  "tired_face": require('images/emoji/tired_face.png'),
  "tm": require('images/emoji/tm.png'),
  "toilet": require('images/emoji/toilet.png'),
  "tokyo_tower": require('images/emoji/tokyo_tower.png'),
  "tomato": require('images/emoji/tomato.png'),
  "tongue": require('images/emoji/tongue.png'),
  "top": require('images/emoji/top.png'),
  "tophat": require('images/emoji/tophat.png'),
  "tractor": require('images/emoji/tractor.png'),
  "traffic_light": require('images/emoji/traffic_light.png'),
  "train": require('images/emoji/train.png'),
  "train2": require('images/emoji/train2.png'),
  "tram": require('images/emoji/tram.png'),
  "trello": require('images/emoji/trello.png'),
  "triangular_flag_on_post": require('images/emoji/triangular_flag_on_post.png'),
  "triangular_ruler": require('images/emoji/triangular_ruler.png'),
  "trident": require('images/emoji/trident.png'),
  "triumph": require('images/emoji/triumph.png'),
  "trolleybus": require('images/emoji/trolleybus.png'),
  "trollface": require('images/emoji/trollface.png'),
  "trophy": require('images/emoji/trophy.png'),
  "tropical_drink": require('images/emoji/tropical_drink.png'),
  "tropical_fish": require('images/emoji/tropical_fish.png'),
  "truck": require('images/emoji/truck.png'),
  "trumpet": require('images/emoji/trumpet.png'),
  "tshirt": require('images/emoji/tshirt.png'),
  "tulip": require('images/emoji/tulip.png'),
  "turtle": require('images/emoji/turtle.png'),
  "tv": require('images/emoji/tv.png'),
  "twisted_rightwards_arrows": require('images/emoji/twisted_rightwards_arrows.png'),
  "two": require('images/emoji/two.png'),
  "two_hearts": require('images/emoji/two_hearts.png'),
  "two_men_holding_hands": require('images/emoji/two_men_holding_hands.png'),
  "two_women_holding_hands": require('images/emoji/two_women_holding_hands.png'),
  "u5272": require('images/emoji/u5272.png'),
  "u5408": require('images/emoji/u5408.png'),
  "u55b6": require('images/emoji/u55b6.png'),
  "u6307": require('images/emoji/u6307.png'),
  "u6708": require('images/emoji/u6708.png'),
  "u6709": require('images/emoji/u6709.png'),
  "u6e80": require('images/emoji/u6e80.png'),
  "u7121": require('images/emoji/u7121.png'),
  "u7533": require('images/emoji/u7533.png'),
  "u7981": require('images/emoji/u7981.png'),
  "u7a7a": require('images/emoji/u7a7a.png'),
  "uk": require('images/emoji/uk.png'),
  "umbrella": require('images/emoji/umbrella.png'),
  "unamused": require('images/emoji/unamused.png'),
  "underage": require('images/emoji/underage.png'),
  "unlock": require('images/emoji/unlock.png'),
  "up": require('images/emoji/up.png'),
  "us": require('images/emoji/us.png'),
  "v": require('images/emoji/v.png'),
  "vertical_traffic_light": require('images/emoji/vertical_traffic_light.png'),
  "vhs": require('images/emoji/vhs.png'),
  "vibration_mode": require('images/emoji/vibration_mode.png'),
  "video_camera": require('images/emoji/video_camera.png'),
  "video_game": require('images/emoji/video_game.png'),
  "violin": require('images/emoji/violin.png'),
  "virgo": require('images/emoji/virgo.png'),
  "volcano": require('images/emoji/volcano.png'),
  "vs": require('images/emoji/vs.png'),
  "walking": require('images/emoji/walking.png'),
  "waning_crescent_moon": require('images/emoji/waning_crescent_moon.png'),
  "waning_gibbous_moon": require('images/emoji/waning_gibbous_moon.png'),
  "warning": require('images/emoji/warning.png'),
  "watch": require('images/emoji/watch.png'),
  "water_buffalo": require('images/emoji/water_buffalo.png'),
  "watermelon": require('images/emoji/watermelon.png'),
  "wave": require('images/emoji/wave.png'),
  "wavy_dash": require('images/emoji/wavy_dash.png'),
  "waxing_crescent_moon": require('images/emoji/waxing_crescent_moon.png'),
  "waxing_gibbous_moon": require('images/emoji/waxing_gibbous_moon.png'),
  "wc": require('images/emoji/wc.png'),
  "weary": require('images/emoji/weary.png'),
  "wedding": require('images/emoji/wedding.png'),
  "whale": require('images/emoji/whale.png'),
  "whale2": require('images/emoji/whale2.png'),
  "wheelchair": require('images/emoji/wheelchair.png'),
  "white_check_mark": require('images/emoji/white_check_mark.png'),
  "white_circle": require('images/emoji/white_circle.png'),
  "white_flower": require('images/emoji/white_flower.png'),
  "white_large_square": require('images/emoji/white_large_square.png'),
  "white_medium_small_square": require('images/emoji/white_medium_small_square.png'),
  "white_medium_square": require('images/emoji/white_medium_square.png'),
  "white_small_square": require('images/emoji/white_small_square.png'),
  "white_square_button": require('images/emoji/white_square_button.png'),
  "wind_chime": require('images/emoji/wind_chime.png'),
  "wine_glass": require('images/emoji/wine_glass.png'),
  "wink": require('images/emoji/wink.png'),
  "wolf": require('images/emoji/wolf.png'),
  "woman": require('images/emoji/woman.png'),
  "womans_clothes": require('images/emoji/womans_clothes.png'),
  "womans_hat": require('images/emoji/womans_hat.png'),
  "womens": require('images/emoji/womens.png'),
  "worried": require('images/emoji/worried.png'),
  "wrench": require('images/emoji/wrench.png'),
  "x": require('images/emoji/x.png'),
  "yellow_heart": require('images/emoji/yellow_heart.png'),
  "yen": require('images/emoji/yen.png'),
  "yum": require('images/emoji/yum.png'),
  "zap": require('images/emoji/zap.png'),
  "zero": require('images/emoji/zero.png'),
  "zzz": require('images/emoji/zzz.png')
};



// WEBPACK FOOTER //
// ./app/scripts/data/emoji.js